import React, { useEffect, useState } from "react";
import { api, formatApiError, ROLE_LABELS } from "../lib/apiClient";
import { PageHeader, ActionButton } from "../components/Layout";
import { UserPlus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

export default function UsersPage() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", name: "", role: "production_operator" });

  const load = async () => {
    try {
      const { data } = await api.get("/users");
      setRows(data);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { if (user && user.role === "admin") load(); }, [user]);

  if (user && user.role !== "admin") {
    return <div className="text-slate-500">Bu sayfaya erişim yetkiniz yok.</div>;
  }

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/users", form);
      toast.success("Kullanıcı eklendi");
      setForm({ email: "", password: "", name: "", role: "production_operator" });
      setShowForm(false);
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const del = async (id) => {
    if (!window.confirm("Bu kullanıcıyı silmek istediğinize emin misiniz?")) return;
    try {
      await api.delete(`/users/${id}`);
      toast.success("Kullanıcı silindi");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <PageHeader
        title="Kullanıcı Yönetimi"
        subtitle="Sistem kullanıcıları ve rolleri"
        actions={
          <ActionButton onClick={() => setShowForm(!showForm)} data-testid="toggle-user-form">
            <UserPlus size={18} /> Yeni Kullanıcı
          </ActionButton>
        }
      />

      {showForm && (
        <form onSubmit={submit} className="card-industrial p-6 mb-6" data-testid="new-user-form">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <Field label="Ad Soyad" required>
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} data-testid="user-name" />
            </Field>
            <Field label="E-posta" required>
              <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls + " font-mono"} data-testid="user-email" />
            </Field>
            <Field label="Şifre" required>
              <input required type="text" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls + " font-mono"} data-testid="user-password" />
            </Field>
            <Field label="Rol">
              <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className={inputCls} data-testid="user-role">
                {Object.entries(ROLE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
            </Field>
          </div>
          <div className="mt-4 text-right">
            <button type="submit" data-testid="save-user-btn" className="px-5 py-2 bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-wide text-sm">Kaydet</button>
          </div>
        </form>
      )}

      <div className="card-industrial overflow-x-auto">
        <table className="w-full text-sm" data-testid="users-table">
          <thead>
            <tr className="bg-slate-100 border-b border-slate-300 text-xs uppercase tracking-widest text-slate-600">
              <th className="text-left px-4 py-3">Ad Soyad</th>
              <th className="text-left px-4 py-3">E-posta</th>
              <th className="text-left px-4 py-3">Rol</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((u, i) => (
              <tr key={u.id} className={`border-b border-slate-200 ${i % 2 === 0 ? "bg-white" : "bg-slate-50"}`} data-testid={`user-row-${u.email}`}>
                <td className="px-4 py-3 font-bold">{u.name}</td>
                <td className="px-4 py-3 font-mono">{u.email}</td>
                <td className="px-4 py-3"><span className="chip chip-siparis">{ROLE_LABELS[u.role]}</span></td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => del(u.id)} className="text-red-700 hover:text-red-900 inline-flex items-center gap-1 text-sm font-bold" data-testid={`delete-${u.email}`}>
                    <Trash2 size={14} /> Sil
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const inputCls = "w-full px-3 py-2 border border-slate-400 bg-white rounded-none focus:border-blue-700 focus:outline-none";

function Field({ label, children, required }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-widest font-bold text-slate-600 mb-1">
        {label}{required && <span className="text-red-600"> *</span>}
      </div>
      {children}
    </label>
  );
}
